import emailjs from "@emailjs/browser";



const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

// Company/Admin recipient email from .env
const COMPANY_EMAIL = process.env.REACT_APP_COMPANY_EMAIL;


export const sendJobApplication = async (formData) => {
  try {
    // ----------------------------------------------------------
    // Configuration validation
    // ----------------------------------------------------------

    if (!PUBLIC_KEY) {
      throw new Error("EmailJS public key is missing.");
    }

    if (!SERVICE_ID) {
      throw new Error("EmailJS service ID is missing.");
    }

    if (!TEMPLATE_ID) {
      throw new Error("EmailJS template ID is missing.");
    }

    if (!COMPANY_EMAIL?.trim()) {
      throw new Error(
        "Company email is missing. Check REACT_APP_COMPANY_EMAIL in .env."
      );
    }

    // ----------------------------------------------------------
    // EmailJS Template Parameters
    // ----------------------------------------------------------

    const templateParams = {

      to_email: COMPANY_EMAIL.trim(),

    
      from_name: formData.name?.trim() || "",
      from_email: formData.email?.trim() || "",
      phone: formData.phone?.trim() || "",

      // Job application details
      job_title: formData.jobTitle?.trim() || "",
      experience: formData.experience?.trim() || "",
      skills: formData.skills?.trim() || "",

      // Resume URL
      resume_url: formData.resume?.trim() || "",
    };

    // ----------------------------------------------------------
    // Optional debugging
    // ----------------------------------------------------------

    console.log("Job application recipient:", templateParams.to_email);

    // ----------------------------------------------------------
    // Send Email Through EmailJS
    // ----------------------------------------------------------

    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );

    // ----------------------------------------------------------
    // Success
    // ----------------------------------------------------------

    return {
      success: true,
      response,
    };

  } catch (error) {
    // ----------------------------------------------------------
    // Error
    // ----------------------------------------------------------

    console.error("EmailJS Job Application Error:", error);

    return {
      success: false,
      error,
    };
  }
};